import { useLocation } from 'react-router-dom';

export default (urls: string[]) => {
  const { pathname } = useLocation();

  const pathnameParts = pathname.split('/');
  const highlightableUrls = ['/'];
  while (pathnameParts.length > 1) {
    highlightableUrls.push(pathnameParts.join('/'));
    pathnameParts.pop();
  }

  const [highlightedUrl] = urls
    .filter((url) => highlightableUrls.includes(url))
    .sort((a, b) => b.length - a.length);

  return highlightedUrl;
};
